if (!customElements.get('media-gallery')) {
  customElements.define(
    'media-gallery',
    class MediaGallery extends HTMLElement {
      constructor() {
        super();
        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };
        this.mql = window.matchMedia('(min-width: 750px)');
        if (!this.elements.thumbnails) return;

        this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
        this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
          mediaToSwitch
            .querySelector('button')
            .addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target));
        });
        if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
      }

      onSlideChanged(event) {
        const thumbnail = this.elements.thumbnails.querySelector(
          `[data-target="${event.detail.currentElement.dataset.mediaId}"]`
        );
        this.setActiveThumbnail(thumbnail);
      }

      setActiveMedia(mediaId) {
        const activeMedia =
          this.elements.viewer.querySelector(`[data-media-id="${mediaId}"]`) ||
          this.elements.viewer.querySelector('[data-media-id]');
        if (!activeMedia) {
          return;
        }
        this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
          element.classList.remove('is-active');
        });
        activeMedia?.classList?.add('is-active');

        this.preventStickyHeader();
        window.setTimeout(() => {
          if (!this.mql.matches || this.elements.thumbnails) {
            activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
          }
          const activeMediaRect = activeMedia.getBoundingClientRect();
          // Don't scroll if the image is already in view
          if (activeMediaRect.top > -0.5) return;
          const top = activeMediaRect.top + window.scrollY;
          window.scrollTo({ top: top, behavior: 'smooth' });
        });
        this.playActiveMedia(activeMedia);

        if (!this.elements.thumbnails) return;
        const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${mediaId}"]`);
        this.setActiveThumbnail(activeThumbnail);
        this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
      }

      setActiveThumbnail(thumbnail) {
        if (!this.elements.thumbnails || !thumbnail) return;

        this.elements.thumbnails
          .querySelectorAll('button')
          .forEach((element) => element.removeAttribute('aria-current'));
        thumbnail.querySelector('button').setAttribute('aria-current', true);
        if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

        this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
      }

      announceLiveRegion(activeItem, position) {
        const image = activeItem.querySelector('.product__modal-opener--image img');
        if (!image) return;
        image.onload = () => {
          this.elements.liveRegion.setAttribute('aria-hidden', false);
          this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace('[index]', position);
          setTimeout(() => {
            this.elements.liveRegion.setAttribute('aria-hidden', true);
          }, 500);
        };
        image.src = image.src;
      }

      playActiveMedia(activeItem) {
        window.pauseAllMedia();
        const deferredMedia = activeItem.querySelector('.deferred-media');
        if (deferredMedia) deferredMedia.loadContent(false);
      }

      preventStickyHeader() {
        this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
        if (!this.stickyHeader) return;
        this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
      }

      removeListSemantic() {
        if (!this.elements.viewer.slider) return;
        this.elements.viewer.slider.setAttribute('role', 'presentation');
        this.elements.viewer.sliderItems.forEach((slide) => slide.setAttribute('role', 'presentation'));
      }
    }
  );
}

// Global variable to store video references for syncing
let globalPrimaryVideo = null;
let globalSecondaryVideo = null;
let syncInterval = null;
let isSyncingPlayPause = false;

function setupVideoSync(primaryVideo, secondaryVideo) {
  if (!primaryVideo || !secondaryVideo) return;
  
  if (primaryVideo._syncListenersAdded) return;
  
  globalPrimaryVideo = primaryVideo;
  globalSecondaryVideo = secondaryVideo;
  primaryVideo._syncListenersAdded = true;

  // Add event listeners for play/pause with debounce flag
  primaryVideo.addEventListener('play', () => {
    if (isSyncingPlayPause) return;
    isSyncingPlayPause = true;
    secondaryVideo.currentTime = primaryVideo.currentTime;
    secondaryVideo.play().catch(() => {});
    setTimeout(() => { isSyncingPlayPause = false; }, 50);
  });

  primaryVideo.addEventListener('pause', () => {
    if (isSyncingPlayPause) return;
    isSyncingPlayPause = true;
    secondaryVideo.currentTime = primaryVideo.currentTime;
    secondaryVideo.pause();
    setTimeout(() => { isSyncingPlayPause = false; }, 50);
  });

  secondaryVideo.addEventListener('play', () => {
    if (isSyncingPlayPause) return;
    isSyncingPlayPause = true;
    primaryVideo.currentTime = secondaryVideo.currentTime;
    primaryVideo.play().catch(() => {});
    setTimeout(() => { isSyncingPlayPause = false; }, 50);
  });

  secondaryVideo.addEventListener('pause', () => {
    if (isSyncingPlayPause) return;
    isSyncingPlayPause = true;
    primaryVideo.currentTime = secondaryVideo.currentTime;
    primaryVideo.pause();
    setTimeout(() => { isSyncingPlayPause = false; }, 50);
  });

  // Keep videos in sync using interval - tight sync for hidden videos
  if (syncInterval) clearInterval(syncInterval);
  
  syncInterval = setInterval(() => {
    if (!primaryVideo || !secondaryVideo) return;
    
    // Sync time with tighter tolerance
    const timeDiff = Math.abs(primaryVideo.currentTime - secondaryVideo.currentTime);
    if (timeDiff > 0.05) {
      if (primaryVideo.currentTime > secondaryVideo.currentTime) {
        try {
          secondaryVideo.currentTime = primaryVideo.currentTime;
        } catch(e) {}
      } else {
        try {
          primaryVideo.currentTime = secondaryVideo.currentTime;
        } catch(e) {}
      }
    }
  }, 50);
}

document.addEventListener('click', (event) => {
  const button = event.target.closest('.story-video-toggle__button');
  if (!button) return;

  const toggle = button.closest('.story-video-toggle');
  const slide = toggle.closest('.product__media-item');

  const primaryMedia = slide.querySelector('.story-video-instance.primary');
  const secondaryMedia = slide.querySelector('.story-video-instance.secondary');

  if (!primaryMedia || !secondaryMedia) return;

  const buttons = toggle.querySelectorAll('.story-video-toggle__button');

  let targetMedia, otherMedia, targetVideo, otherVideo;

  if (button === buttons[0]) {
    targetMedia = primaryMedia;
    otherMedia = secondaryMedia;
    targetVideo = targetMedia.querySelector('video');
    otherVideo = otherMedia.querySelector('video');
  } else {
    targetMedia = secondaryMedia;
    otherMedia = primaryMedia;
    targetVideo = targetMedia.querySelector('video');
    otherVideo = otherMedia.querySelector('video');
  }

  // Sync the hidden video only if paused (avoid lag during playback)
  if (targetVideo && otherVideo) {
    if (otherVideo.paused) {
      // Only sync currentTime when video is paused
      targetVideo.currentTime = otherVideo.currentTime;
    } else {
      // If playing, just ensure target video is also playing - sync interval will handle timing
      if (targetVideo.paused) {
        targetVideo.play().catch(() => {});
      }
    }
  }

  // Smooth transition with CSS instead of abrupt visibility changes

  
  targetMedia.style.opacity = 1;
  targetMedia.style.visibility = 'visible';
  targetMedia.style.pointerEvents = 'auto';
  
  otherMedia.style.opacity = 0;
  otherMedia.style.visibility = 'hidden';
  otherMedia.style.pointerEvents = 'none';

  // Update pause icon visibility based on actual video state
  const targetPause = targetMedia.querySelector('.deferred-media__icon--pause');
  const otherPause = otherMedia.querySelector('.deferred-media__icon--pause');

  // Pause icon shown when video is playing (hidden when paused)
  if (targetPause && targetVideo) {
    targetPause.hidden = targetVideo.paused;
  }
  if (otherPause) {
    otherPause.hidden = true;
  }

  buttons.forEach(btn => btn.setAttribute('aria-pressed','false'));
  button.setAttribute('aria-pressed','true');
});
document.addEventListener("DOMContentLoaded", () => {
  const primaryMedia = document.querySelector('.story-video-instance.primary');
  const secondaryMedia = document.querySelector('.story-video-instance.secondary');
  
  if (!primaryMedia || !secondaryMedia) return;

  // Pre-load both videos immediately
  if (primaryMedia.getAttribute('loaded') !== 'true') {
    requestAnimationFrame(() => primaryMedia.loadContent(false, true));
  }
  if (secondaryMedia.getAttribute('loaded') !== 'true') {
    requestAnimationFrame(() => secondaryMedia.loadContent(false, true));
  }

  const waitForVideos = () => {
    const primaryMedia = document.querySelector('.story-video-instance.primary');
    const secondaryMedia = document.querySelector('.story-video-instance.secondary');
    const primaryDeferred = primaryMedia ? primaryMedia.querySelector('deferred-media') : null;
    const secondaryDeferred = secondaryMedia ? secondaryMedia.querySelector('deferred-media') : null;

    let primaryVideo = primaryMedia ? primaryMedia.querySelector('video') : null;
    let secondaryVideo = secondaryMedia ? secondaryMedia.querySelector('video') : null;

    if (!primaryVideo && primaryDeferred && primaryDeferred.loadContent) {
      primaryDeferred.loadContent(false);
      primaryVideo = primaryMedia.querySelector('video');
    }
    if (!secondaryVideo && secondaryDeferred && secondaryDeferred.loadContent) {
      secondaryDeferred.loadContent(false);
      secondaryVideo = secondaryMedia.querySelector('video');
    }

    if (!primaryVideo || !secondaryVideo) {
      setTimeout(waitForVideos, 100);
      return;
    }

    // Configure for iOS
    primaryVideo.preload = 'auto';
    secondaryVideo.preload = 'auto';
    primaryVideo.setAttribute('playsinline', '');
    secondaryVideo.setAttribute('playsinline', '');

    // Setup sync with interval (no event cascades)
    setupVideoSync(primaryVideo, secondaryVideo);

    // Ensure both videos start at the same time
    primaryVideo.currentTime = 0;
    secondaryVideo.currentTime = 0;

    // Hide secondary initially - keep layout intact
    secondaryMedia.style.opacity = 0;
    secondaryMedia.style.visibility = 'hidden';
    secondaryMedia.style.pointerEvents = 'none';

    // Play both videos - they stay in sync via interval
    primaryVideo.play().catch(()=>{});
    secondaryVideo.play().catch(()=>{});

    console.log('Both videos loaded and synced');
  };
  
  waitForVideos();
});